import { render, staticRenderFns } from "./ModalExcluirTerceiro.vue?vue&type=template&id=639c2b56"
import script from "./ModalExcluirTerceiro.vue?vue&type=script&lang=js"
export * from "./ModalExcluirTerceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports